import React from "react";
import { SafesitePromise } from "./SafesitePromise";
import Container from "./Container";
import Section from "./Section";
import Grid from "./Grid";
import { AreasCoveredBanner } from "./AreasCoveredBanner";

export const AreasCoveredAndSafeSiteBanner = () => {
  return (
    <Section>
      <Container>
        <Grid equalHeight>
          <Grid item lg="8">
            <AreasCoveredBanner />
          </Grid>
          <Grid item lg="4">
            <SafesitePromise />
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
};
